"use client";

import React from "react";

import { useBoundariesEditMode } from "@/app/(internal)/panel/(maps)/_contexts/boundaries-edit-mode-context";
import { WorkMapMapLevelBoundaryPanel } from "@/app/(internal)/panel/(maps)/map/_components/work-map-map-level-boundary-panel";

import {
  BoundaryPanelContent,
  type BoundarySchoolSelectVariant,
} from "./boundary-panel-content";
import { BoundaryPanelSkeleton } from "./boundary-panel-plotting-section";

import type { IBoundaryPayload } from "../../map-panel-context";

interface BoundaryPanelRouterProps {
  payload: IBoundaryPayload | null;
  isLoading: boolean;
  schoolSelectVariant?: BoundarySchoolSelectVariant;
}

export const BoundaryPanelRouter: React.FC<BoundaryPanelRouterProps> = ({
  payload,
  isLoading,
  schoolSelectVariant,
}) => {
  const { editingKind, isBoundariesEditMode } = useBoundariesEditMode();

  if (isBoundariesEditMode && editingKind === "mapLevel") {
    return <WorkMapMapLevelBoundaryPanel />;
  }

  if (isLoading && !payload) {
    return <BoundaryPanelSkeleton />;
  }

  if (!payload) {
    return null;
  }

  return (
    <BoundaryPanelContent
      payload={payload}
      schoolSelectVariant={schoolSelectVariant}
    />
  );
};
